import React from 'react'
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import {routesBase} from "v4/data/appRoutes"
import AdminCard from "v4/components/ui/AdminCard/AdminCard";
import useCustomEventTriggersForm
    from "v4/pages/admin/CustomEventTriggers/components/CustomEventTriggersForm/hooks/useCustomEventTriggersForm";
import FormRender from "v4/components/form/FormRender/FormRender";
import SubmitButton from "v4/components/ui/SubmitButton/SubmitButton";
import PolButton from "v4/components/ui/PolButton/PolButton";
import InlineLoader from "v4/components/ui/InlineLoader/InlineLoader";
import CustomEventTriggersFormRender
    from "v4/pages/admin/CustomEventTriggers/components/CustomEventTriggersForm/components/CustomEventTriggersFormRender";
import {CHOICE_TYPE} from "v4/data/fieldTypes";
import {toCapitalize} from "v4/utils";
import FieldWrapper from "v4/components/form/FieldWrapper/FieldWrapper";

export default function CustomEventTriggersForm({customerId, id}) {
    const {t} = usePolTranslation();
    const {
        form,
        isLoading,
        isLoadingSave,
        handleSave,
    } = useCustomEventTriggersForm(customerId, id);

    return (
        <AdminCard title={t('manage_custom_event_triggers')}
                   CardHeaderTools={() => (
                       <>
                           <PolButton to={routesBase.adminCustomEventTriggers}>
                               {t('return')}
                           </PolButton>
                           <SubmitButton isLoading={isLoadingSave} formId="customEventTriggerForm">
                               {t('enregistrer')}
                           </SubmitButton>
                       </>
                   )}
        >
            {isLoading
                ? <InlineLoader/>
                : (
                    <div>
                        <FormRender form={form}
                                    onSubmit={handleSave}
                                    formId="customEventTriggerForm"
                                    formClassName="row"
                                    fieldRender={(field) => {
                                        if (field.type === CHOICE_TYPE && field.choices[0].label === '0') {
                                            field.choices = field.choices.map(choice => ({
                                                ...choice,
                                                label: toCapitalize(t(choice.value)),
                                            }));
                                        }

                                        return (
                                            <FieldWrapper field={field}
                                                          name={field.name}
                                                          className={`col-md-6 mb-4 ${field.attr?.type === 'hidden' ? 'd-none' : ''}`}/>
                                        )
                                    }}>
                            <CustomEventTriggersFormRender/>
                        </FormRender>
                        <div>
                            <p>{t('configuration_tokens_available')} :</p>
                            <ul className="pl-4">
                                <li>%managedBy.initials%</li>
                                <li>%issuedAt%</li>
                                <li>%tenantId%</li>
                                <li>%increment-end-when-field-begin-like:padding%</li>
                                <br/>
                                <li>
                                    %date|value|format% =&gt; {t('for_example')} :
                                    <p>%date|first day of February next year|d-m-Y%</p>
                                    <p>%date|yesterday|d-m-Y h:i%</p>
                                    <p>%date|now|d/m/Y%</p>
                                    <p>{t('warning_task_field_date_must_be')}</p>
                                    <p>Y-m-d\TH:i : {t('for_example')} =&gt; %date|now|Y-m-d\TH:i%</p>
                                </li>
                            </ul>
                            <p>{t('custom_event_trigger_date_value_attempted')} :</p>
                        </div>
                    </div>
                )
            }
        </AdminCard>
    )
}
